export default defineComponent({
  name: 'CustomSkeletonPreloader'
});